<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <filters ref="filters" @filter="filter" @report="report" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="username"
              class="reporteusuarios dataTable"
              sort-by="username"
              :sort-desc="false"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field
                  v-model.trim="search"
                  dense
                  clearable
                  hide-details
                  :label="$t('view.commons.search')"
                  append-icon="mdi-magnify"
                  @keydown.enter="refreshSearch"
                  @click:append="refreshSearch"
                  @click:clear="clearSearch" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>
  </v-card>
</template>
<script>
import Filters from "@/views/reportes/reporteusuarios/Filters"; /** *******************************/
import ReporteUsuariosAPI from "@/services/reportes/reporteusuarios"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

export default {
  components: { Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.reportes.reporteusuarios.tabla.username"), align: "left", sortable: true, class: "tablaHeader", cellClass: "username", value: "username", width: "170px" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.nombre"), align: "left", sortable: true, class: "tablaHeader", cellClass: "nombre", value: "nombre", width: "300px" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.enabled"), align: "center", sortable: true, class: "tablaHeader", cellClass: "enabled", value: "enabled" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.tipoUsuario"), align: "left", sortable: true, class: "tablaHeader", cellClass: "tipoUsuario", value: "tipoUsuario", width: "150px" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.vendor"), align: "left", sortable: true, class: "tablaHeader", cellClass: "vendor", value: "vendor", width: "180px" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.rep"), align: "center", sortable: true, class: "tablaHeader", cellClass: "rep", value: "rep" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.email"), align: "left", sortable: true, class: "tablaHeader", cellClass: "correoElectronico", value: "correoElectronico" }
              , { text: this.$t("view.reportes.reporteusuarios.tabla.celular"), align: "left", sortable: true, class: "tablaHeader", cellClass: "celular", value: "celular", width: "150px" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const tipoUsuario = this.$store.getters.getUserData.tipoUsuario;
      if (tipoUsuario == "VENDOR") {
        this.filtros.vendor = this.$store.getters.getUserData.idVendor;
      }

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await ReporteUsuariosAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , refreshData() {
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      await this.load();
    }
    , async report() {
      if (this.view.elem.datatable.total <= 0) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.minregs"));
        return false;
      }

      if (this.view.elem.datatable.total > 50000) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.maxregs"));
        return false;
      }

      this.$refs.filters.loading(true);

      try {
        const serverSideDataT = this.prepareData();
        const response = await ReporteUsuariosAPI.report(serverSideDataT);
        if (response && response.data.size > 0) {
          const url = globalThis.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", response.headers.filename.replaceAll("\"", "")); // or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.errrep"));
        }
      } catch (error) {
        console.error(error);
      }

      this.$refs.filters.loading(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/reportes/reporteusuarios/DataTable.vue